// AI Schemas for LLD and HLD Components
// Centralized schemas for consistent AI responses across the application

// ========================
// LLD SCHEMAS
// ========================
// Note: LLD_EVALUATION_SCHEMA and LLD_HINT_SCHEMA removed - not used (prompts were removed)
// PATTERN_EVALUATION_SCHEMA and PATTERN_HINT_SCHEMA removed - design pattern questions now use direct validation
// LLD only uses: Clarification schema and Code Evaluation schema

export const LLD_CLARIFICATION_SCHEMA = {
  answer: "string"
};

// ========================
// HLD SCHEMAS
// ========================

export const HLD_EVALUATION_SCHEMA = {
  verdict: "string", // "PASS" | "PARTIAL" | "FAIL"
  feedback: "string", // Detailed feedback on what's correct, incorrect, and needs clarification
  followUpQuestion: "string" // Single follow-up question that explores missing/deeper aspects (only one per main question)
};

export const HLD_CLARIFICATION_SCHEMA = {
  answer: "string"
};

export const NON_FUNCTIONAL_REQUIREMENT_EVALUATION_SCHEMA = {
  status: "string", // "CORRECT", "INCORRECT", or "REPEATED"
  feedback: "string"
};

export const API_EVALUATION_SCHEMA = {
  status: "string", // "CORRECT", "INCORRECT", or "REPEATED"
  feedback: "string"
};

// API_DIAGRAM_EVALUATION_SCHEMA removed - evaluation not used for API diagrams

// ========================
// TODAY'S QUESTION SCHEMA
// ========================

export const TODAYS_QUESTION_FEEDBACK_SCHEMA = {
  errors: "string",
  improvements: "string",
  missed_points: "string",
  additional_info_needed: "string",
  overall_assessment: {
    strength_areas: "string",
    weakness_areas: "string",
    complexity_level: "string",
    next_steps: "string"
  }
};

// ========================
// NOTES SCHEMAS
// ========================

export const NOTES_QUESTION_GENERATION_SCHEMA = {
  questions: [
    {
      question: "string",
      difficulty: "string", // easy, medium, hard
      topic: "string",
      explanation: "string"
    }
  ],
  total_questions: "number",
  note_summary: "string"
};

export const NOTES_ANSWER_EVALUATION_SCHEMA = {
  feedback: "string",
  score: "number", // 1-10 scale
  strengths: "string",
  improvements: "string",
  correctness: "string", // correct, partially_correct, incorrect
  additional_resources: "string"
};

// ========================
// CODE EVALUATION SCHEMA
// ========================
// Note: COMBINED_DIAGRAM_EVALUATION_SCHEMA removed - not used (prompt was removed)

export const CODE_EVALUATION_SCHEMA = {
  codeAreasNeedingImprovement: "string", // Specific code locations (file names, class names, method names) where more robust, clean, and modular code can be written, with details on what makes it less robust/clean/modular
  missingDesignPatterns: "string", // Which design patterns are MISSED in the code where they should be applied, with specific locations and reasons
  designPatternOpportunities: "string", // Specific code sections where design patterns CAN BE APPLIED to improve the code, with exact locations and how they would improve it
  missingFeatures: "string", // Any features from requirements that are missing or incomplete in the code, with what needs to be added
  assessment: "string" // Overall assessment summary
};

// ========================
// SCHEMA COLLECTIONS
// ========================

// LLD-specific schemas
export const LLD_SCHEMAS = {
  CLARIFICATION: LLD_CLARIFICATION_SCHEMA
  // PATTERN_EVALUATION and PATTERN_HINT removed - design pattern questions now use direct validation
};

// HLD-specific schemas
export const HLD_SCHEMAS = {
  EVALUATION: HLD_EVALUATION_SCHEMA,
  CLARIFICATION: HLD_CLARIFICATION_SCHEMA,
  NON_FUNCTIONAL_REQUIREMENT_EVALUATION: NON_FUNCTIONAL_REQUIREMENT_EVALUATION_SCHEMA,
  API_EVALUATION: API_EVALUATION_SCHEMA
};

// Notes-specific schemas
export const NOTES_SCHEMAS = {
  QUESTION_GENERATION: NOTES_QUESTION_GENERATION_SCHEMA,
  ANSWER_EVALUATION: NOTES_ANSWER_EVALUATION_SCHEMA
};

// Code evaluation schema
export const CODE_EVALUATION_SCHEMAS = {
  CODE: CODE_EVALUATION_SCHEMA
};

// All schemas combined
export const AI_SCHEMAS = {
  LLD: LLD_SCHEMAS,
  HLD: HLD_SCHEMAS,
  TODAYS_QUESTION: TODAYS_QUESTION_FEEDBACK_SCHEMA,
  NOTES: NOTES_SCHEMAS,
  CODE_EVALUATION: CODE_EVALUATION_SCHEMAS
};
